<template>
<div>
  <v-card>
    <trade-request-response-list></trade-request-response-list>
  </v-card>
</div>
</template>
<script>
import TradeRequestResponseList from '../components/TradeRequestResponseList.vue';
export default {
  data() {
    return {};
  },
  components: {
    TradeRequestResponseList,
  },
  methods: {
    
  },
};
</script>

<style></style>